const routeNewsList = () => '/allnews';

export default routeNewsList;
